import { render, staticRenderFns } from "./RelatorioDetalhe.vue?vue&type=template&id=d1505976&scoped=true"
import script from "./RelatorioDetalhe.vue?vue&type=script&lang=ts"
export * from "./RelatorioDetalhe.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioDetalhe.vue?vue&type=style&index=0&id=d1505976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1505976",
  null
  
)

export default component.exports